import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getUsers } from 'modules/_common/api';

export const useQueryUsers = () => {
  return useQuery(QUERY_KEYS.RENTALS_USERS, getUsers, getCacheSettings());
};
